import { ChangeDetectorRef, Component, inject, Input, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, NgModel, Validators } from '@angular/forms';
import { DropdownOption, ModalDialogActive } from '@ddv/common-components';
import { LabelValuePair, MetadataFormatUtils, AGG_TYPES_BY_SECTION_AND_DISPLAY, TooltipConfigItem } from '@ddv/models';

@Component({
    selector: 'ddv-column-tooltip-formatting',
    templateUrl: './column-tooltip-formatting.component.html',
    styleUrls: ['../column-formatting-grid/column-formatting-grid.component.scss'],
    providers: [NgModel],
    standalone: false,
})
export class ColumnTooltipFormattingComponent implements OnInit {
    @Input() parentData: TooltipConfigItem | undefined;

    protected readonly modalDialogActive = inject(ModalDialogActive<TooltipConfigItem>);
    private readonly fb = inject(FormBuilder);
    private readonly cdr = inject(ChangeDetectorRef);

    protected configForm: FormGroup | undefined;
    protected aggTypes: DropdownOption[] | undefined;
    protected numberFormats: DropdownOption[] | undefined;

    ngOnInit(): void {
        if (!this.parentData) {
            return console.error('Cannot initialize this component without parentData');
        }

        this.aggTypes = AGG_TYPES_BY_SECTION_AND_DISPLAY.tooltip[this.parentData.displayType ?? '']
            .map((t: LabelValuePair<string>) => {
                return { text: t.label, key: t.value, value: t.value };
            });
        this.numberFormats = MetadataFormatUtils.getNumberFormats().map((t) => ({ text: t.label, key: t.value, value: t.value }));

        this.initForm(this.parentData);
        this.toggleCustomNameField();
    }

    protected toggleCustomNameField(): void {
        if (!this.configForm) {
            return;
        }

        if (this.configForm.controls.showCustomName.value) {
            this.configForm.controls.customName.enable();
        } else {
            this.configForm.controls.customName.disable();
        }
    }

    private initForm(data: TooltipConfigItem): void {
        this.configForm = this.fb.group(
            {
                customName: [data.customName],
                showCustomName: [data.showCustomName],
                aggregationType: [data.aggregationType],
                numberFormat: [data.numberFormat],
                decimalPlaces: [data.decimalPlaces],
            },
            {
                validators: (control: AbstractControl) => {
                    const formGroup = control;
                    const showCustomName = formGroup.get('showCustomName');
                    const customName = formGroup.get('customName');

                    if (!showCustomName || !customName) {
                        return null;
                    }

                    if (showCustomName.value) {
                        customName.setValidators(Validators.required);
                    } else {
                        customName.clearValidators();
                    }

                    return null;
                },
            },
        );
        this.cdr.detectChanges();
    }
}
